<template>
  <div class="container">
    <vue-dropzone
      ref="myVueDropzone"
      :include-styling="false"
      :useCustomSlot="true"
      id="dropzone"
      @vdropzone-upload-progress="uploadProgress"
      :options="dropzoneOptions"
      @vdropzone-file-added="fileAdded"
      @vdropzone-sending-multiple="sendingFiles"
      @vdropzone-success-multiple="success"
    >
      <div class="dropzone-container">
        <div class="file-selector">
          Prenesite datoteku ili 
          <v-btn small elevation="0" color="primary" type="button">Odaberi</v-btn>
        </div>
      </div>
    </vue-dropzone>
    <AttachmentList ref="list"
      v-on:removeFile="removeFile"
      :tempAttachments="getTempAttachments"
      :attachments="getAttachments"
      :isInEdit='isInEdit'
      :selectedRad="selectedRad"
    />
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import AttachmentList from "./AttachmentList";
import { mapGetters } from "vuex";
export default {
  name: "Attachment",
  props: ["noviRadDialog","isInEdit", "selectedRad"],
  
  data() {
    return {
      addedFile: {},
      tempAttachments: [],
      attachments: [],
      dropzoneOptions: {
        // The Url Where Dropped or Selected files will be sent
        url: `https://api.sum.ba/files`,
        // File Size allowed in MB
        maxFilesize: 102400000,
        // The way you want to receive the files in the server
        paramName: function() {
          return "file";
        },
        withCredentials: true,
        dictDefaultMessage: "Upload Files Here",
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 20
      }
    };
  },
  components: {
    vueDropzone: vue2Dropzone,
    AttachmentList: AttachmentList
  },
  methods: {
    // function called for every file dropped or selected
    fileAdded(file) {
    //   console.log("File Dropped => ", file);
      // Construct your file object to render in the UI
      let attachment = {};
      attachment.id = null
      attachment._id = file.upload.uuid;
      attachment.title = file.name;
      attachment.name = file.name;
      attachment.type = "file";
      attachment.extension = "." + file.type.split("/")[1];
      attachment.user = JSON.parse(localStorage.getItem("user"));
      attachment.content = "File Upload by Select or Drop";
      attachment.thumb = file.dataURL;
      attachment.thumb_list = file.dataURL;
      attachment.isLoading = true;
      attachment.progress = 0;
      attachment.size = file.size;
      this.tempAttachments = [...this.tempAttachments, attachment];
      this.addedFile = attachment
    },
    // a middle layer function where you can change the XHR request properties
    sendingFiles(files, xhr, formData) {
      formData.append('name', this.addedFile.name);
    },
    // function where we get the upload progress
    uploadProgress(file, progress, bytesSent) {
      console.log("File Upload Progress", progress, bytesSent);
      this.tempAttachments.map(attachment => {
        if (attachment.title === file.name) {
          attachment.progress = `${Math.floor(progress)}`;
        }
      });
    },
    // called on successful upload of a file
    success(file, response) {
      this.tempAttachments.map(attachment => {
        if (attachment.title === response.name && !attachment.id) {
          // console.log(attachment, response)
          attachment.id =  response.id;
        }
      });
      this.$store.dispatch('addFileId', response.id )
    },
    removeFile(file){
      this.tempAttachments = this.tempAttachments.filter(ta => ta.id != file.id)
      this.$store.dispatch('removeFileById', file.id)
    },
    reset(){
      this.tempAttachments = [];
    }
  },
  computed: {
     ...mapGetters['getDokumenti'],
    getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments() {
      return this.attachments;
    }
  },
  watch:{
    noviRadDialog(val){
      if(!val){
        this.reset()
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-selector {
  padding: 55px;
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: center; */
  /* align-content: center; */
  font-weight: 600;
  background-color: #f9f9f9;
  color: #4e5b69;
  z-index: 10;
}
figure {
  margin: 0px;
}

.dropzone-container {
  display: flex;
  flex-direction: row;
    justify-content: center;
  align-content: center;
  border: 1px dashed #ccc;
  border-radius: 15px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

span {
  position: relative;
  background: #f9f9f9;
  padding: 0 4px;
  z-index: 9;
  font-size: 12px;
  color: #4e5b69;
}
</style>
